<div #containerList class="list">
  <p-table
    [hidden]="isLoading || (!isLoading && !list?.length)"
    [value]="list | filterListByString : searchValueControl : isDriverMode"
    [scrollable]="true"
    [scrollHeight]="listHeight"
  >
    <ng-template pTemplate="header">
      <tr>
        <th class="name-column" style="min-width: 300px; width: 300px">
          <!-- <p-checkbox
            (ngModelChange)="onChangeValueCheckedAll($event)"
            [(ngModel)]="isCheckedAll"
            [binary]="true"
          ></p-checkbox> -->
          <span>{{ isDriverMode ? ('labels.driver'|translate) : ('labels.vehicle' | translate) }}</span>
        </th>
        <th style="min-width: 135px; width: 135px">
          {{ "lastDownload" | translate }}
        </th>
        <th style="min-width: 135px; width: 135px">
          {{ "legalDeadline" | translate }}
        </th>
        <th style="min-width: 200px; width: 200px">
          {{ "downloadStatus" | translate }}
        </th>
        <th style="width: 140px; min-width: 140px;">
          {{ "downloadMode" | translate }}
        </th>
        <th *ngIf="!isDriverMode" style="width: 180px; min-width: 180px;">
          {{ "companyCardVehicle" | translate }}
        </th>
        <th style="min-width: 200px; width: 200px">
          {{ "actions" | translate }}
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-item>
      <tr class="list__item">
        <td class="name-column">
          <!-- <p-checkbox
            #checkboxItem
            (click)="
              $event.stopPropagation(); onCheckedItem(checkboxItem, item)
            "
            [binary]="true"
          ></p-checkbox> -->
          <span>
            {{ isDriverMode ? (item.Driver.FN + ' ' + item.Driver.LN) : item.Vehicle.Nm }}
          </span>
        </td>
        <td>
          {{
            item.LastFileLoadDate
              ? (item.LastFileLoadDate | date : "dd.MM.yyyy  HH:mm")
              : "-"
          }}
        </td>
        <td style="display: flex; align-items: center">
          <app-tachograph-list-download-deadline
            [data]="item"
          ></app-tachograph-list-download-deadline>
        </td>
        <td>
          <app-current-file-status-on-list
            [data]="item"
          ></app-current-file-status-on-list>
        </td>
        <td>
          <p-selectbutton
            [options]="stateOptions"
            (ngModelChange)="onChangeDownloadMode($event, item)"
            [(ngModel)]="item.AutoDownloadEnabled"
            optionLabel="label"
            optionValue="value"
            aria-labelledby="basic"
            [allowEmpty]="false"
          />
        </td>
        <td *ngIf="!isDriverMode">
          <p-select
            [options]="companyCards"
            [(ngModel)]="item.CompanyCardNumber"
            optionLabel="Name"
            optionValue="Number"
            [showClear]="true"
            (onChange)="onChangeCompanyCard($event, item)"
            styleClass="w-full"
            [placeholder]="'default' | translate"
          />
        </td>
        <td>
          <div class="list__item__actions">
            <button (click)="openFiles$.emit(isDriverMode ? (item.Driver.FN + ' ' + item.Driver.LN) : item.Vehicle.Nm)" class="action">
              <div class="action__content">
                <i class="pi pi-folder-open"></i>
                {{'files'|translate}}
              </div>
            </button>

            <button
              #forceVehicleFile
              [disabled]="
                item.Status === TACHO_FILE_STATUS.Waiting ||
                item.Status === TACHO_FILE_STATUS.VehicleOffline ||
                item.Status === TACHO_FILE_STATUS.DownloadInProgress ||
                item.Status === TACHO_FILE_STATUS.AuthorizationInProgress ||
                item.Status === TACHO_FILE_STATUS.FleetCardBusy
              "
              (click)="forceFile(forceVehicleFile, item)"
              class="action"
              [attr.data-file]="isDriverMode ? item.DriverId : item.VehicleId"
            >
              <div class="action__content default-state">
                <i class="pi pi-cloud-download"></i>
                {{'getRemote'|translate}}
              </div>
              <div class="action__content download-state">
                <i class="pi pi-cloud-download"></i>
                {{
                  item.Status === TACHO_FILE_STATUS.Waiting ||
                  item.Status === TACHO_FILE_STATUS.VehicleOffline ||
                  item.Status === TACHO_FILE_STATUS.DownloadInProgress ||
                  item.Status === TACHO_FILE_STATUS.AuthorizationInProgress ||
                  item.Status === TACHO_FILE_STATUS.FleetCardBusy
                    ? ('waiting'|translate)
                    : ('downloading'|translate)
                }}
              </div>
            </button>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <div *ngIf="isLoading" class="list__loader">
    <p-skeleton *ngFor="let item of [1,1,1,1,1,1,1,1,1,1,1,1,1,1,1]" height="3.6rem"></p-skeleton>
  </div>

  <app-tachograph-file-status-empty-list
    *ngIf="!isLoading && !list?.length"
    [desc]="isDriverMode ? ('noDriverDataFound'|translate) : ('noVehicleDataFound'|translate)"
  ></app-tachograph-file-status-empty-list>
</div>
